export const themeConfig = {
  appLogoImage: null,
  titleBarLogo: "/logo.png",
  logoText: "DOTwe",
  appName: "DOTwe",
  primaryColor: "#141414",
  primaryColorLight: "rgba(0, 0, 0, 0.4)",
  secondaryColor: "#fff",
  errorColor: "#ff4d4f",
  fontFamily: "montserrat",
  sidebarTheme: "light", // "light" or "dark"
};
